import React from 'react'
import { css } from '@linaria/core'
import { boolAttr } from '@fs/zion-frontend-friends'
import { useTranslation } from 'react-i18next'
import { colors, Avatar } from '@fs/zion-ui'
import { EventMarriage } from '@fs/zion-icon'

const timelineItemCss = css`
  position: relative;
  border-radius: 60px;
  font-size: 10px;
  line-height: 11px;
  color: ${colors.gray90};
  white-space: nowrap;
  height: 24px;
  padding-left: 10px;
  display: flex;
  align-items: center;

  &[use-small-timeline] {
    width: 3px;
  }

  &[show-background] {
    background-color: ${colors.gray05};
  }

  &::not([show-background]) {
    background: none;
  }

  &[gender='male'][show-background][focus-item] {
    background-color: ${colors.blue05};
  }

  &[gender='female'][show-background][focus-item] {
    background-color: ${colors.red20};
  }

  &[focus-item] {
    font-weight: bold;
  }
`

const timelineLifespanCss = css`
  font-size: 9px;
  margin-left: 8px;
`

const iconCss = css`
  position: absolute;
  left: -28px;
`

const smallTimelineCss = css`
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 60px;
  background-color: ${colors.gray05};
  width: 2px;
  height: 24px;

  &[gender='male'][focus-item] {
    background-color: ${colors.blue05};
  }

  &[gender='female'][focus-item] {
    background-color: ${colors.red20};
  }
`

export default function TimelineItem({
  name,
  startYear,
  endYear,
  totalStartYear,
  gender,
  row,
  lifespan,
  focusItem,
  type,
  date,
}) {
  const [t] = useTranslation()
  const gridColumnStart = startYear - totalStartYear + 1
  let gridColumnEnd = endYear - totalStartYear + 1
  if (!endYear) gridColumnEnd = gridColumnStart

  // Should use small, 2px wide, timeline bar
  const useSmallTimeline = gridColumnStart === gridColumnEnd || !endYear || type === 'MARRIAGE'

  return (
    <div
      className={timelineItemCss}
      style={{
        gridRowStart: row,
        gridColumnStart,
        gridColumnEnd,
      }}
      show-background={boolAttr(gridColumnStart !== gridColumnEnd)}
      gender={gender}
      focus-item={boolAttr(focusItem)}
      use-small-timeline={boolAttr(useSmallTimeline)}
    >
      {useSmallTimeline && <div className={smallTimelineCss} gender={gender} focus-item={boolAttr(focusItem)} />}
      {type === 'MARRIAGE' ? (
        <>
          <div>{t('info-cards.timeline.marriage.label', { date })}</div>
          <div className={iconCss}>
            <EventMarriage />
          </div>
        </>
      ) : (
        <>
          <div>{name}</div>
          <div className={iconCss}>
            <Avatar sex={gender} size="xs" />
          </div>
          <div className={timelineLifespanCss}>{lifespan}</div>
        </>
      )}
    </div>
  )
}
